import { AxiosError } from 'axios';

import { httpClient } from '../index';

type Req = {
    planId: number;
    code?: string;
};

type Res = {
    error?: string;
    data?: {
        id: number;
        code: string;
    };
};

export const createGiftCard = async (req: Req, token: string): Promise<Res> => {
    try {
        const res = await httpClient.post('/api/admin/coupons/giftcard', req, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return { data: res.data };
    } catch (err) {
        const error = err as AxiosError;
        if (error.response?.status === 409) {
            return { error: 'conflict' };
        }
        return { error: 'server_error' };
    }
};
